import ScrollWrapper from "../../Components/ScrollWrapper";
import Text from "../../Components/Text";
import SmallImage from "../../Components/SmallImage";
import TIcon from "../../Components/TIcon";
import ChapterToggler from "../../Components/ChapterToggler";

const UI = () => {
    return (
        <ScrollWrapper>
            <div className="w-full h-full flex flex-col p-3 gap-4">
                <Text type="maintitle">Die Benutzeroberfläche</Text>
                <SmallImage src={"instructions/ui-interface.png"} />

                {/* Übersicht */}
                <div className="w-full flex flex-col">
                    <Text type="title">1. Workspace Dropdown</Text>
                    <Text type="title">2. Benutzer Icon</Text>
                    <Text type="title">3. Hauptmenu</Text>
                    <Text type="title">4. Hauptinhalt</Text>
                </div>

                {/* 1. Workspace Dropdown */}
                <ChapterToggler title="1. Workspace Dropdown">
                    <Text type="itemtext">
                        Das Workspace Dropdown ist dafür zuständig, seinen aktuellen Workspace
                        (oder auch Restaurant genannt) auszuwählen oder zu wechseln.
                    </Text>
                    <br />
                    <SmallImage src={"instructions/ws-dropdown.png"} smallSize="w-60" />
                </ChapterToggler>

                {/* 2. Benutzer Icon */}
                <ChapterToggler title="2. Benutzer Icon">
                    <Text type="itemtext">
                        Hier werden die Initialen des angemeldeten Benutzers angezeigt.
                        Durch das Anklicken wird ein Fenster geöffnet, in dem man die Seite
                        neu laden oder sich abmelden kann.
                    </Text>
                    <br />
                    <SmallImage src={"instructions/user-modal.png"} smallSize="w-60" />
                </ChapterToggler>

                {/* 3. Hauptmenu */}
                <ChapterToggler title="3. Hauptmenu">
                    <Text type="itemtext">
                        Im Hauptmenu kann man die gewünschte Seite anzeigen lassen.
                        Zudem kann man durch das Drücken des <TIcon name={"menu-2"} /> Symbols
                        das Menu ein- oder ausklappen.
                    </Text>
                    <br />
                    <div className="flex gap-4 flex-wrap">
                        <SmallImage
                            src={"instructions/sidebar-manager.png"}
                            smallSize="w-60"
                            subtitle="Mit Manager Rolle"
                        />
                        <SmallImage
                            src={"instructions/sidebar-default.png"}
                            smallSize="w-60"
                            subtitle="Ohne Manager Rolle"
                        />
                    </div>
                </ChapterToggler>

                {/* 4. Hauptinhalt */}
                <ChapterToggler title="4. Hauptinhalt">
                    <Text type="itemtext">
                        Hier wird der Hauptinhalt angezeigt, welchen man über das Hauptmenu
                        ausgewählt hat.
                    </Text>
                    <br />
                    <SmallImage
                        src={"instructions/main-example.png"}
                        smallSize="w-full"
                        subtitle="Beispiel: Statistik Inhalt"
                    />
                </ChapterToggler>
            </div>
        </ScrollWrapper>
    );
};

export default UI;
